import { Component } from '@angular/core';

@Component({
  selector: 'false-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  styles: [
  ]
})
export class ConfirmDeleteDialogComponent {

}
